"use strict";Object.defineProperty(exports,"__esModule",{value:!0});var e=require("react/jsx-runtime"),s=require("styled-components"),i=require("@vds/typography"),r=require("@vds/lines"),t=require("@vds-tokens/core"),a=require("./pricing-list-item.js");function n(e){return e&&e.__esModule?e:{default:e}}var o=n(s);const l=o.default.ul.withConfig({displayName:"List",componentId:"VDS__sc-jxpimq-0"})`
  display: flex;
  flex-direction: column;
  gap: ${t.LayoutTokens.space["4X"].value};
  margin: 0px;
  padding: 0px;
`,d=o.default.div.withConfig({displayName:"Wrapper",componentId:"VDS__sc-jxpimq-1"})`
  display: flex;
  flex-direction: column;
  gap: ${t.LayoutTokens.space["4X"].value};
`;exports.default=s=>{const{data:n,surface:o="light",title:u,hideLine:c}=s;return e.jsxs(d,{children:[u&&e.jsx(i.Body,Object.assign({color:t.ColorTokens.elements.secondary[`on${o}`].value,size:"small"},u)),!c&&e.jsx(r.Line,{type:"secondary"}),e.jsx(l,{children:n&&n.map(((s,i)=>e.jsx(a.default,Object.assign({surface:o},s),i)))})]})};
